import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import {
	Icon,
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@uturn/ui-kit';
import { useTranslation } from 'react-i18next';

export function HiddenFieldLabelInfo() {
	const { t } = useTranslation();
	return (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger asChild>
					<button
						className="ml-1 flex size-5 items-center justify-center rounded-2xl bg-transparent"
						type="button"
					>
						<Icon icon={faEyeSlash} className="text-secondary-700 size-3.5" />
					</button>
				</TooltipTrigger>
				<TooltipContent>
					{t(
						'pages.shipment.tooltip.hidden_fields.info',
						'Information visible after carrier has been assigned',
					)}
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
}
